import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import './responsive.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PageNotFound from './pages/PageNotFound';
import Branches from './pages/Branches';
import Branch from './features/branch/pages/branch';
import OnboardingStatusPage from './pages/OnboardingStatusPage';
import OnboardingProcessPage from './pages/OnboardingProcessPage';
import OnboardingObjectPage from './pages/OnboardingObjectPage';
import SystemSettings from './pages/SystemSettings';
import AppActivityPage from './pages/AppActivityPage';
import QueriesPage from './pages/QueriesPage';
import FeatureRequestsPage from './pages/FeatureRequestsPage';
import ContactUsPage from './pages/ContactUsPage';
import LoginLogsPage from './pages/LoginLogsPage';
import PublishedPage from './pages/PublishedPage';
import DatabaseSheetsPage from './pages/DatabaseSheetsPage';
import EmployeeManagement from './pages/EmployeeManagement';
import TecfolkActivityPage from './pages/TecfolkActivityPage';
import { ThemeProvider } from './theme/ThemeContext';
import Login from './pages/Login';
import TrashPage from './pages/TrashPage';
import ProtectedRoute from './components/ProtectedRoute';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
      <Routes>
        <Route path='/' element={<Login/>} />
        <Route path='/dashboard' element={<ProtectedRoute><App/></ProtectedRoute>} />
        <Route path='/web-dashboard' element={<ProtectedRoute><App/></ProtectedRoute>} />
        <Route path='/system-settings' element={<ProtectedRoute><SystemSettings/></ProtectedRoute>} />
        <Route path='/trash' element={<ProtectedRoute><TrashPage/></ProtectedRoute>} />
        <Route path='/employee-management' element={<ProtectedRoute><EmployeeManagement/></ProtectedRoute>} />
        <Route path='/branches' element={<ProtectedRoute><Branches/></ProtectedRoute>} />
        <Route path='/app-activity/:userSlug?' element={<ProtectedRoute><AppActivityPage/></ProtectedRoute>} />
        <Route path='/queries' element={<ProtectedRoute><QueriesPage/></ProtectedRoute>} />
        <Route path='/tecfolk-activity' element={<ProtectedRoute><TecfolkActivityPage/></ProtectedRoute>} />
        <Route path='/feature-requests' element={<ProtectedRoute><FeatureRequestsPage/></ProtectedRoute>} />
        <Route path='/mobile-dashboard' element={<ProtectedRoute><App/></ProtectedRoute>} />
        <Route path='/mobile-clients' element={<ProtectedRoute><Branches/></ProtectedRoute>} />
        <Route path='/contact-us' element={<ProtectedRoute><ContactUsPage/></ProtectedRoute>} />
        <Route path='/login-logs' element={<ProtectedRoute><LoginLogsPage/></ProtectedRoute>} />
        <Route path='/published' element={<ProtectedRoute><PublishedPage/></ProtectedRoute>} />
        <Route path='/database-sheets' element={<ProtectedRoute><DatabaseSheetsPage/></ProtectedRoute>} />
        <Route path='/onboarding' element={<ProtectedRoute><OnboardingProcessPage/></ProtectedRoute>} />
        <Route path='/onboarding-status' element={<ProtectedRoute><OnboardingStatusPage/></ProtectedRoute>} />
        <Route path='/onboarding-object' element={<ProtectedRoute><OnboardingObjectPage/></ProtectedRoute>} />
        <Route path='/branches/:id' element={<ProtectedRoute><Branch/></ProtectedRoute>} />
        <Route path='*' element={<ProtectedRoute><PageNotFound/></ProtectedRoute>} />
      </Routes>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (e.g. pass a reporter function)
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
